'use strict';

var BaseStaticView = require('actions/shared/AbstractStaticView');
var tpl = require('actions/lanPolicy/static.html');
var twig = require('twig').twig;

/**
 * Renders a text-only version of the LAN policies component.
 */
module.exports = BaseStaticView.extend({
  /**
   * @name actions/lanPolicy/StaticView#model
   * @type {actions/lanPolicy/LanPolicy}
   */

  template: twig({data: tpl}),
});
